export default "__VITE_ASSET__CIRSl20U__"